import { render, staticRenderFns } from "./vehicleRuleDetailsBox.vue?vue&type=template&id=8975fc70"
import script from "./vehicleRuleDetailsBox.vue?vue&type=script&lang=js"
export * from "./vehicleRuleDetailsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports